module.exports = __webpack_public_path__ + "img/asset-account-fuel.10d32972.svg";